import React from "react";
import "./app.css";
import { Utils } from "../../js/utils.js";

//Components
import LoadingScreen from "../loading-screen/loading-screen";
import MuralHotspots from "../mural-hotspots/mural-hotspots";
import Viewer from "../viewer/viewer";
import GalleryPane from "../gallery-pane/gallery-pane";
import FilterButtons from "../filter-buttons/filter-buttons";

//Services
import { mirrorService } from "../../services/mirror.service";
//import { metricsService } from "../../services/metrics.service";
import { truMetriXService, Event, Environment } from "@ixperientialmedia/ixp_services";

class App extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			loaderState: "hide",
			loaderProgress: 0,
			muralBG: null,
			kioskBG: null,
			hotspotMap: [],
			filter: [],
			activeHotspot: null,
			activeSubParent: null,
			activeSubHotspot: null,
			copyTitle: null,
			copyText: null,
			activeMedia: null,
			videoState: null,
			shouldHotspotsVisible: true,
			posterPath: '',
			isPhone: this.phoneCheck(),
			isiPad: navigator.userAgent.match(/Macintosh/i) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2,
			isMobileUrl: new URLSearchParams(window.location.search).get('mobile') == '1'
		};

		this.appContainer = React.createRef();
		this.fullscreenSplashContainer = React.createRef();
		this.screenOrientationSplashContainer = React.createRef();

		this.mode = Utils.getURLParameter('mode') || 'web';
		this.frameSrc = "./assets/left_frame_web.png";
		this.hotspots = {};
		this.landingPosterPath = '';
		this.posterPathTimer;
		this.toggleSubHotspot = this.toggleSubHotspot.bind(this);
		switch (this.mode) {
			case 'wall':
				this.frameSrc = "./assets/WALL_left_frame.png"
			case 'kiosk':
				this.frameSrc = "./assets/left_frame.png";
				document.querySelector('html').classList.add(this.mode);
				this.mirrorRefs = [];
				let refsNeeded = 0;
				for (let i = 0; i < refsNeeded; i++) {
					this.mirrorRefs.push(React.createRef());
				}
				mirrorService.init(this, this.mode === 'kiosk', this.mode === 'wall');
				break;
		}
	}

	gotoFullscreen = () => {
		if (document.fullscreenEnabled && !this.state.isiPad) {
			this.appContainer.current.requestFullscreen()
			.then(() => {
				if (screen.orientation.lock) {
					screen.orientation.lock('landscape').then(() => {
					}).catch(err => {
						console.log('screen orientation lock error:', err);
					});
				} else {
					this.appContainer.current.classList.add('not-able-to-lock-orientation');
				}
			})
			.catch(err => { 
				console.log(err); 
			});
		} else {
			
		}
	}

	mobileAddressBarVisibilityCheck = () => {
		if (Number(document.body.dataset.initialHeight) > window.innerHeight) {
			document.body.style.overflow = 'auto';
			this.appContainer.current.style.height = '200vh';
			if (window.innerWidth > window.innerHeight) {
				this.fullscreenSplashContainer.current.style.display = 'block';
			}
			// window.removeEventListener('scroll', this.hideMobileAddressBar);
			// window.addEventListener('scroll', this.hideMobileAddressBar, {once: true});
		}
	}

	hideMobileAddressBar = () => {
		setTimeout(() => {
			window.scrollTo(0,0);
			this.appContainer.current.style.height = '100%';
			this.fullscreenSplashContainer.current.style.display = 'none';
			document.body.style.overflow = 'hidden';
			const initHeight = Number(document.body.dataset.initialHeight);
			if (window.innerWidth > window.innerHeight && (initHeight == 0 || initHeight < window.innerHeight)) {
				document.body.dataset.initialHeight = window.innerHeight;
			}
		}, 1000);
	}

	phoneCheck = () => {
		var userAgent = navigator.userAgent || navigator.vendor || window.opera;
		if (userAgent.match(/iPhone/i) || userAgent.match(/iPod/i))
			return 'iOS';
		// else if (userAgent.match(/Macintosh/i) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2)
		// 	return 'iPad';
		else if (userAgent.match(/Android/i))
			return 'Android';
		else if (userAgent.match(/Mobi/i))
			return 'Others';
		else
			return false;
	}

	_createPartObject = (cms, part, partId, hsMode, hsListWebName, hsListWallName, PARENT_ID_BY_SUB_HOTSPOT_ID = null) => {
		let title = part.Title || part.Name;
		let partName = part.Name.split('-').pop();
		let partHSData = {
			web: this.findSubHotspotByParentHotspotId(cms.HotspotList[`${hsListWebName}-web`] || null, partId),
			wall: this.findSubHotspotByParentHotspotId(cms.HotspotList[`${hsListWallName}-wall`] || null, partId)
		};
		return {
			Id: partId,
			Name: partName,
			Filter: part.Filter || [],
			hotspotText: title,
			Title: title,
			Copy: part.Copy,
			Camera: part.Camera,
			PCHotspotName: part.PCHotspotName,
			Background: part[`${hsMode}_Background`] ? "./library/" + cms.media[part[`${hsMode}_Background`]].filename : null,
			Model: part.Model,
			HotspotPos: partHSData,
			Gallery: (part.Gallery || []).map(medId => { return { path: "./library/" + cms.media[medId].filename, thumb: "./library/thumb/" + cms.media[medId].thumb } }),
			ParentId: PARENT_ID_BY_SUB_HOTSPOT_ID ? PARENT_ID_BY_SUB_HOTSPOT_ID[partId] : null
		}
	}

	_stopPropagation = (evt) => {
		evt.stopPropagation();
	}
	   
	_freezePC = (shouldFreeze = false) => {
		if (!pc || !pc.app) {
			return;
		}
		const events = ['click', 'dblclick', 'mousedown', 'mouseup', 'mousemove', 'wheel', 'drag', 'touchstart', 'touchmove', 'touchend'];
		pc.app.autoRender = !shouldFreeze;
		if (shouldFreeze) {
			events.forEach(evt => pc.app.graphicsDevice?.canvas?.addEventListener(evt, this._stopPropagation));
		} else {
			events.forEach(evt => pc.app.graphicsDevice?.canvas?.removeEventListener(evt, this._stopPropagation));
		}
	}

	componentDidMount() {
		if (this.state.isPhone || this.state.isiPad) {
			if (document.fullscreenEnabled && !this.state.isiPad) {
				this.appContainer.current.addEventListener('fullscreenchange', evt => {
					this.fullscreenSplashContainer.current.style.display = document.fullscreenElement ? 'none' : 'block';
				});
			} else {
				this.appContainer.current.classList.add('fullscreen-not-available');
				window.setInterval(() => {
					this.mobileAddressBarVisibilityCheck();
				}, 1000);

				document.body.style.overflow = 'auto';
				this.appContainer.current.style.height = '200vh';
				document.body.dataset.initialHeight = 0;

				window.addEventListener('scroll', evt => {
					this.hideMobileAddressBar();
				});

				// window.addEventListener('resize', evt => {
				// 	this.hideMobileAddressBar();
				// });
			}
		}

		// document.addEventListener('contextmenu', e => {e.preventDefault()});

		if (this.mode == 'wall') {
			fetch("./style.config.json")
				.then(response => response.json())
				.then(styleVars => {
					for (let key in styleVars) {
						document.querySelector(':root').style.setProperty(key, styleVars[key]);
					}
				})
			return;
		}

		fetch("./library/AVIATION_PAS23-" + ((location.href.indexOf('rtx.ixperiential.com') == -1 || location.href.indexOf('stag') != -1) ? "staging" : "production") + ".json")
			.then(response => response.json())
			.then(cms => {
				let hsMode = this.mode === 'web' ? 'Web' : 'Wall';
				let hotspots = [];
				const allHotspots = Object.assign({}, cms.Hotspots, cms.SubHotspots);
				const PARENT_ID_BY_SUB_HOTSPOT_ID = {};
				for (let i in allHotspots) {
					for (let j of allHotspots[i].Sub_Hotspots || []) {
						PARENT_ID_BY_SUB_HOTSPOT_ID[j] = i;
					}
				}

				for (let i in cms.HotspotList[hsMode].data) {
					let hs = cms.HotspotList[hsMode].data[i];
					hotspots.push({
						id: hs.id,
						index: cms.General.Hotspot_Order?.indexOf(hs.id),
						top: hs.y,
						left: hs.x,
						name: cms.Hotspots[hs.id].Name,
						filter: cms.Hotspots[hs.id].Filter || [],
						background: cms.Hotspots[hs.id].Background ? "./library/" + cms.media[cms.Hotspots[hs.id].Background].filename : null,
						thumb: cms.Hotspots[hs.id].Thumb_Image ? "./library/" + cms.media[cms.Hotspots[hs.id].Thumb_Image].filename : null,
						subhotspots: (cms.Hotspots[hs.id].Sub_Hotspots || []).map(hid => { return { name: cms.Hotspots[hid].Title || cms.Hotspots[hid].Name, id: hid } }),
						PosterPath: cms.HotspotList[`${cms.Hotspots[hs.id].Name}-web`]?.background ? './library/' + cms.media[cms.HotspotList[`${cms.Hotspots[hs.id].Name}-web`].background]?.filename : ''
					});
				}

				for (let i in allHotspots) {
					let hs = allHotspots[i];
					let hsTitle = hs.Copy_Title || hs.Title || hs.Name;
					let _name = hs.Name.split('-').pop();
					let _subhotspots = {};
					(hs.Sub_Hotspots || []).forEach(sid => {
						_subhotspots[allHotspots[sid].Name] = {
							PCHotspotName: allHotspots[sid].PCHotspotName || '',
							Filter: allHotspots[sid].Filter || []
						}
					});
					let tmpHS = {
						id: i,
						Name: _name,
						Filter: hs.Filter || [],
						Title: hsTitle,
						Copy: hs.Copy,
						Background: hs[`${hsMode}_Background`] ? "./library/" + cms.media[hs[`${hsMode}_Background`]].filename : null,
						KioskBackground: cms.media[hs.Web_Background]?.filename ? "./library/" + cms.media[hs.Web_Background]?.filename : null,
						Model: hs.Model,
						Tag: hs.Tag,
						Camera: hs.Camera,
						PCHotspotName: hs.PCHotspotName,
						Gallery: [],
						Parts: hs.Parts?.length > 0 ? {} : null,
						SubHotspots: _subhotspots,
						ModelsToShow: hs.ModelsToShow,
						ModelsToHide: hs.ModelsToHide,
						ParentId: PARENT_ID_BY_SUB_HOTSPOT_ID[i] || null,
						ParentTitle: PARENT_ID_BY_SUB_HOTSPOT_ID[i] ? allHotspots[PARENT_ID_BY_SUB_HOTSPOT_ID[i]].Title : '',
						PosterPath: cms.HotspotList[`${hs.Name}-web`]?.background ? './library/' + cms.media[cms.HotspotList[`${hs.Name}-web`].background]?.filename : '',
						ShowFirstAsset: hs.ShowFirstAsset?.[0] ? true : false
					}

					for (let medId of hs.Gallery || []) {
						tmpHS.Gallery.push({ path: "./library/" + cms.media[medId].filename, thumb: "./library/thumb/" + cms.media[medId].thumb });
					}

					for (let partId of hs.Parts || []) {
						let part = cms.SubHotspots[partId];
						let partName = part.Name.split('-').pop();
						tmpHS.Parts[partName] = this._createPartObject(cms, part, partId, hsMode, hs.Name, hs.Name, PARENT_ID_BY_SUB_HOTSPOT_ID);
						
						tmpHS.Parts[partName].SubHotspots = part.Sub_Hotspots && part.Sub_Hotspots.map(subHsId => {
							let subPart = cms.SubHotspots[subHsId];
							let result = this._createPartObject(cms, subPart, subHsId, hsMode, part.Name, hs.Name, PARENT_ID_BY_SUB_HOTSPOT_ID);
							result.SubHotspots = subPart.Sub_Hotspots && subPart.Sub_Hotspots.map(subSubHsId => {
								let subSubPart = cms.SubHotspots[subSubHsId];
								return this._createPartObject(cms, subSubPart, subSubHsId, hsMode, subPart.Name, hs.Name, PARENT_ID_BY_SUB_HOTSPOT_ID);
							});
							return result;
						}) || [];

						tmpHS.Parts[partName].Parts = part.Parts && part.Parts.map(subPartId => {
							let subPart = cms.SubHotspots[subPartId];
							return this._createPartObject(cms, subPart, subPartId, hsMode, partName, hs.Name, PARENT_ID_BY_SUB_HOTSPOT_ID);
						});
					}
					this.hotspots[i] = tmpHS;
				}

				// make dictionary by Name & by PC hotspot Name
				this.hotspotNameDic = {};
				this.hotspotPCNameDic = {};
				for (let key in this.hotspots) {
					this.hotspotNameDic[this.hotspots[key].Name] = this.hotspots[key];

					if (this.hotspots[key].PCHotspotName) {
						this.hotspotPCNameDic[this.hotspots[key].PCHotspotName + (this.hotspots[key].ParentId || '')] = this.hotspots[key];
					}
				}

				this.landingPosterPath = cms.HotspotList[hsMode]?.background ? './library/' + cms.media[cms.HotspotList[hsMode].background]?.filename : '';

				this.setState({
					muralBG: "./library/" + cms.media[cms.General[`${hsMode}_Background`]].filename,
					kioskBG: "./library/" + cms.media[cms.General.Kiosk_Background].filename,
					hotspotMap: hotspots,
					posterPath: this.landingPosterPath
				});
			});

		setTimeout(() => {
			//This is website
			if(location?.href?.indexOf('rtx.ixperiential.com') != -1) {
				let updatedConfig = {environment: {show: 'Web'}};
				//This is staging website
				if(location.href.indexOf('stag') != -1) {
					updatedConfig.urls = ["https://stag-agg.trumetrix.net/api/record"];
				}
				
				let visitStatus = localStorage.metricsSessionID ? 'ReturnVisit' : 'NewVisit';
				localStorage.metricsSessionID = Utils.createUUID();

				truMetriXService.updateConfig(updatedConfig);
				truMetriXService.setSessionID(localStorage.metricsSessionID);
				truMetriXService.recordInteractionEvent(visitStatus);
			}
		}, 5000);
	}

	pcLoading = state => {
		if (!isNaN(state)) {
			this.setState({
				loaderState: '',
				loaderProgress: state
			})
		}
		else {
			this.setState({
				loaderState: state
			})
		}
	}

	getFileName = (path) => {
		return path && path.replace(/^.*[\\\/]/, '');
	}

	selectFilter = vals => {
		this.setState({
			filter: vals
		});
	}

	openHotspot = id => {
		if (this.mode !== 'wall') {
			if(this.hotspots[id].Title !== this.state.activeHotspot?.Title) {
				truMetriXService.setComponent(this.hotspots[id].Title);
			}
			//metricsService.record("Open_Hotspot", this.hotspots[id].Title, 1);
		}

		const posterPath = this.hotspots[id]?.PosterPath || this.landingPosterPath;
		
		this.setState({
			activeHotspot: this.hotspots[id],
			activeSubHotspot: null,
			activeMedia: null,
			videoState: null,
			copyText: null,
			copyTitle: null
		});

		if (this.state.isPhone || this.state.isiPad || this.state.isMobileUrl) {
			clearTimeout(this.posterPathTimer);
			this.posterPathTimer = setTimeout(() => {
				this.setState({
					posterPath: posterPath
				})
			}, 2000);
		}

	}

	toggleSubHotspot = (pcHotspotName) => {
		let activeSubHotspot = this.hotspotPCNameDic[pcHotspotName + (this.state.activeSubHotspot?.id || '')];
		let title = activeSubHotspot.Title;
		let copy = activeSubHotspot.Copy;
		if (this.state.copyTitle === activeSubHotspot.Title) {
			if (activeSubHotspot.ParentId) {
				activeSubHotspot = this.hotspots[activeSubHotspot.ParentId];
				title = activeSubHotspot.Title;
				copy = activeSubHotspot.Copy;
			} else {
				activeSubHotspot = null;
				title = null;
				copy = null;
			}

			//metricsService.record("Close_Subhotspot", [this.state.activeHotspot?.Title, this.state.activeSubHotspot?.Title].filter(e => e), 2);
			truMetriXService.recordCloseEvent(Environment.SCENE);
		}

		if (title) {
			truMetriXService.setScene(title);
			//metricsService.record("Open_Subhotspot", [this.state.activeHotspot?.Title, activeSubHotspot ? activeSubHotspot.Title : null].filter(e => e), 2);
		}

		const activeMedia = activeSubHotspot.ShowFirstAsset && activeSubHotspot?.Gallery?.[0]?.path || null;

		this.setState({
			activeSubHotspot: activeSubHotspot,
			activeMedia: activeMedia,
			videoState: activeMedia ? 'open' : null,
			copyTitle: title,
			copyText: copy
		})
	}

	togglePart = (partName, partId, subParentId) => {
		let activeSubHotspot = partId ? this.hotspots[partId] : this.hotspotNameDic[partName];
		let title = activeSubHotspot.Title;
		let copy = activeSubHotspot.Copy;
		if (this.state.copyTitle === activeSubHotspot.Title) {
			if (activeSubHotspot.ParentId) {
				activeSubHotspot = this.hotspots[activeSubHotspot.ParentId];
				title = activeSubHotspot.Title;
				copy = activeSubHotspot.Copy;
			} else {
				activeSubHotspot = null;
				title = null;
				copy = null;
			}
			//metricsService.record("Close_Subhotspot", [this.state.activeHotspot?.Title, this.state.activeSubHotspot?.Title].filter(e => e), 2);
			truMetriXService.recordCloseEvent(Environment.SCENE);
		}

		if (title) {
			//metricsService.record("Open_Subhotspot", [this.state.activeHotspot?.Title, activeSubHotspot ? activeSubHotspot.Title : null].filter(e => e), 2);
			truMetriXService.setScene(title);
		}

		const posterPath = !activeSubHotspot?.ParentId ? activeSubHotspot?.PosterPath : (this.hotspots[activeSubHotspot.ParentId].PosterPath || this.landingPosterPath);

		const activeMedia = activeSubHotspot.ShowFirstAsset && activeSubHotspot?.Gallery?.[0]?.path || null;
		
		this.setState({
			activeSubHotspot: activeSubHotspot,
			activeSubParent: activeSubHotspot && Object.keys(activeSubHotspot.Parts || {}).length > 0 ? activeSubHotspot : (subParentId ? this.hotspots?.[subParentId] : null),
			activeMedia: activeMedia,
			videoState: activeMedia ? 'open' : null,
			copyTitle: title,
			copyText: copy
		});
		
		if (this.state.isPhone || this.state.isiPad || this.state.isMobileUrl) {
			clearTimeout(this.posterPathTimer);
			this.posterPathTimer = setTimeout(() => {
				this.setState({
					posterPath: posterPath
				})
			}, 2000);
		}
	}

	toggleMedia = media => {
		if (this.state.activeMedia === media) {
			//metricsService.record("Close_Media", [this.state.activeHotspot.Title, this.state.activeSubHotspot?.Title, this.getFileName(media)].filter(e => e), 3);
			truMetriXService.recordCloseEvent(Environment.MEDIA);
			this._freezePC(false);
			return;
		} else {
			let valArray = [this.state.activeHotspot.Title];
			if (this.state.activeSubHotspot?.Gallery) {
				valArray.push(this.state.activeSubHotspot.Title);
			}
			if (media) {
				valArray.push(this.getFileName(media));
				truMetriXService.setMedia(this.getFileName(media));
				//metricsService.record("Open_Media", valArray, 3);
				this._freezePC(true);
			}
		}

		this.setState({
			activeMedia: media,
			videoState: "open"
		})
	}

	closeViewer = e => {
		// if (this.mode == 'web') {
		// this.setState({
		// 	activeMedia: null,
		// 	videoState: null
		// });
		// } else {
		if (!e) {	// gallery close button
			this.setState({
				activeMedia: null,
				videoState: null
			});
		} else if (this.state.activeHotspot?.Camera || this.state.activeSubHotspot?.Camera) {
			const activeSubHotspot = this.state.activeSubHotspot?.ParentId ? this.hotspots[this.state.activeSubHotspot.ParentId] : null;
			let title = activeSubHotspot ? activeSubHotspot.Title : null;
			let text = activeSubHotspot ? activeSubHotspot.Copy : null;

			if (!this.state.activeSubHotspot && this.state.activeHotspot) {
				//metricsService.record("Close_Hotspot", this.state.activeHotspot.Title, 1);
				truMetriXService.recordCloseEvent(Environment.COMPONENT);
			}

			if (this.state.activeSubHotspot) {
				//metricsService.record("Close_Subhotspot", this.state.activeSubHotspot.Title, 2)
				truMetriXService.recordCloseEvent(Environment.SCENE);
			}

			const activeHotspot = this.state.activeSubHotspot ? this.state.activeHotspot : (this.state.activeHotspot?.ParentId ? this.hotspots[this.state.activeHotspot.ParentId] : null);

			this.setState({
				activeHotspot: activeHotspot,
				activeSubHotspot: activeSubHotspot,
				activeMedia: null,
				videoState: null,
				copyTitle: title,
				copyText: text,
				posterPath: activeSubHotspot ? (!activeSubHotspot.ParentId ? activeSubHotspot.PosterPath : '') : (activeHotspot ? activeHotspot.PosterPath : this.landingPosterPath)
			});
		} else {
			if (this.state.activeHotspot) {
				//metricsService.record("Close_Hotspot", this.state.activeHotspot.Title, 1);
				truMetriXService.recordCloseEvent(Environment.COMPONENT);
			}

			if (this.state.activeSubHotspot) {
				//metricsService.record("Close_Subhotspot", this.state.activeSubHotspot.Title, 2);
				truMetriXService.recordCloseEvent(Environment.SCENE);
			}

			let activeHotspot = this.state.activeSubHotspot && this.state.activeHotspot || this.state.activeHotspot?.ParentId && this.hotspots[this.state.activeHotspot.ParentId] || null;

			let activeSubHotspot = null;

			if (this.state.activeSubHotspot?.ParentId) {
				activeSubHotspot = this.hotspots[this.state.activeSubHotspot.ParentId];
			} else if (this.state.activeSubParent && this.state.activeSubParent === this.state.activeSubHotspot) {
				activeHotspot = null;
				activeSubHotspot = null;
			} else {
				activeSubHotspot = this.state.activeSubParent || null;
			}

			this.setState({
				activeHotspot: activeHotspot,
				activeSubHotspot: activeSubHotspot,
				activeMedia: null,
				videoState: null,
				copyTitle: activeSubHotspot ? activeSubHotspot.Title : null,
				copyText: activeSubHotspot ? activeSubHotspot.Copy : null,
				posterPath: activeHotspot && activeHotspot.PosterPath || this.landingPosterPath
			});
		}

		if (this.state.activeMedia) {
			//metricsService.record("Close_Media", this.getFileName(this.state.activeMedia), 3);
			truMetriXService.recordCloseEvent(Environment.MEDIA);
			this.setState({
				activeMedia: null,
				videoState: null
			});
		}

		this._freezePC(false);

		clearTimeout(this.posterPathTimer);
		// }
	}

	updateVidState = state => {
		this.setState({
			videoState: state
		});
	}

	goHome = () => {

		if (this.state.activeHotspot) {
			//metricsService.record("Close_Hotspot", this.state.activeHotspot.Title, 1);
			truMetriXService.recordCloseEvent(Environment.COMPONENT);
		}

		this.setState({
			activeHotspot: null,
			activeSubHotspot: null,
			activeMedia: null,
			videoState: null,
			copyTitle: null,
			copyText: null,
			posterPath: this.landingPosterPath
		});

		this._freezePC(false);

		clearTimeout(this.posterPathTimer);
	}

	toggleHotspot = () => {
		this.setState({
			shouldHotspotsVisible: !this.state.shouldHotspotsVisible
		});
	}

	findSubHotspotByParentHotspotId = (hotspotList, id) => {
		if (!hotspotList || !id) {
			return { x: 0, y: 0 };
		} else {
			for (let key in hotspotList.data) {
				if (hotspotList.data[key].id == id) {
					return hotspotList.data[key];
				}
			}
			return { x: 0, y: 0 };
		}
	}

	render() {
		this.state.hotspotMap && this.state.hotspotMap.sort((a, b) => { return a.index - b.index });
		return (
			<div ref={ this.appContainer } className="app-container">
				{ (this.state.isPhone || this.state.isiPad) && 
				<>
					<div ref={ this.fullscreenSplashContainer } className="fullscreen-splash-container" onTouchEnd={ this.gotoFullscreen }>
						<p>{ (this.state.isPhone == 'iOS' || this.state.isiPad) ? 'Swipe up to explore.' : 'Tap to explore.'}</p>
					</div>
					<div ref={ this.screenOrientationSplashContainer } className="screen-orientation-splash-container"><p>For the best user interface experience,<br />please use landscape mode.</p></div>
				</>
				}
				<LoadingScreen
					className={this.state.loaderState}
					progress={this.state.loaderProgress}>
				</LoadingScreen>
				<div id="wrapper" className={`${this.state.isPhone ? 'mobile' : ''} ${this.mode} ${this.state.activeHotspot && (!this.state.activeHotspot.SubHotspots || Object.keys(this.state.activeHotspot.SubHotspots).length == 0) ? "viewer-on" : ""} ${this.state.shouldHotspotsVisible ? 'hotspots-on' : 'hotspots-off'}`}>
					<div id="title">Connected Aviation</div>
					{this.mode != 'kiosk' && <div id="logo" />}
					{/* <img id="left_frame" src={this.frameSrc} /> */}
					<MuralHotspots
						mode={this.mode}
						hotspots={this.state.hotspotMap}
						background={this.state.muralBG}
						kioskbackground={this.state.kioskBG}
						pcLoading={this.pcLoading}
						filter={this.state.filter}
						activeId={this.state.activeHotspot?.id}
						posterPath={this.mode == 'web' ? this.state.posterPath : ''}
						openHS={this.openHotspot}>
					</MuralHotspots>
					<Viewer
						mode={this.mode}
						isPhone={this.state.isPhone}
						isiPad={this.state.isiPad}
						isMobileUrl={this.state.isMobileUrl}
						hotspot={this.state.activeHotspot}
						subparent={this.state.activeSubParent}
						subhotspot={this.state.activeSubHotspot}
						copyTitle={this.state.copyTitle}
						copyText={this.state.copyText}
						pcLoading={this.pcLoading}
						filter={this.state.filter}
						togglePart={this.togglePart}
						toggleSubHotspot={this.toggleSubHotspot}
						closeViewer={this.closeViewer}
						pcHotspotsVisibility={this.state.shouldHotspotsVisible}
					>
					</Viewer>
					<GalleryPane
						mode={this.mode}
						media={this.state.activeMedia}
						videoState={this.state.videoState}
						updateVidState={this.updateVidState}
						thumbnails={this.state.activeSubHotspot?.Gallery || this.state.activeHotspot?.Gallery}
						toggleMedia={this.toggleMedia}
						closeViewer={this.closeViewer}>
					</GalleryPane>
					<FilterButtons
						hotspot={this.state.activeHotspot}
						filter={this.state.filter}
						selectFilter={this.selectFilter}>
					</FilterButtons>
					{this.mode != 'wall' &&
						<div id="bottomBtns">
							<div className="homeBtn" onClick={this.goHome}></div>
							<div className={`hotspotBtn ${this.state.shouldHotspotsVisible ? 'on' : ''}`} onClick={this.toggleHotspot}></div>
						</div>
					}
				</div>
			</div>
		);
	}
}

export default App;
